/*    
<summary>
  This functional component is used for proper authentication of user using the Login Credentials (Username & Password)
  Developer:Mohammad Saquib Khan, Created Date:20-Aug-2025
</summary>
<returns>Returns JSX</returns>
*/

import base64 from "base-64";
import { Field, Form, Formik } from "formik";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FormattedMessage } from "react-intl";
import { useHistory, useLocation } from "react-router-dom";
import monozlogo from "../../../assets/Images/logo--white.png";
import { AuthType } from "../../../constants/enums/auth-type-enum";
import { useStore } from "../../../contexts/store-provider";
import LoaderButton from "../../../shared-components/button/loader-button";
import FormikFormInput from "../../../shared-components/FormikFormHandlers/FormikFormInput";
import { StoreChangePasswordValidateSchema, UserChangePasswordValidateSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import { ShowHidePasswordButton } from "../../../shared-components/Grid/custom-grid-formatter";
import Label from "../../../shared-components/label/label";
import RoutesConstants from "../../../shared-components/routes/routes-constants";
import { formatMessage } from "../../../translations/format-message";
import "../login.css";
import { getTokenFromLocalStorage } from "../../../helpers/localstorage-helper";
import { safeBase64Encode } from "../../../constants/constants";

const ResetPassword = (props: any) => {
  const history = useHistory();
  const { authStore, preferencesStore } = useStore();
  const {
    AuthenticateCustomerAuthCodeService,
    isCustomerAuthCodeValidated,
    authenticateCustomerAuthCodeState,
    resetAuthenticateCustomerAuthCode,
    ResetPasswordService,
    resetPasswordState,
    logout,
  } = authStore;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const authCode = searchParams.get("authCode");
  const email = searchParams.get("email");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showHideNewPassword, setShowHideNewPassword] = useState(false);

  useEffect(() => {
    if (email && authCode) {
      AuthenticateCustomerAuthCodeService({
        AuthCode: authCode,
        Email: email,
        AuthType: AuthType.PasswordResetLinkAuth,
      });
    }
  }, [email, authCode]);

  useEffect(() => {
    if (authenticateCustomerAuthCodeState.success) {
      // toast.success(formatMessage("updated_success"));
    }
  }, [authenticateCustomerAuthCodeState.success]);

  useEffect(() => {
    if (resetPasswordState.success) {
      toast.success(formatMessage("password_changed"));
      setTimeout(() => {
        history.push(RoutesConstants.CustomerLogin);
      }, 2000);
    }
  }, [resetPasswordState.success]);

  useEffect(() => {
    if (resetPasswordState.error) {
      toast.success(formatMessage(resetPasswordState.error));
    }
  }, [resetPasswordState.error]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "changePasswordError" of the useEffect changed.
   */
  useEffect(() => {
    if (authenticateCustomerAuthCodeState.error) {
      toast.error(formatMessage("invalid_link"));
      resetAuthenticateCustomerAuthCode();
    }
  }, [authenticateCustomerAuthCodeState.error]);

  const changePassword = (values: any) => {
    ResetPasswordService({
      Email: email,
      NewPassword: safeBase64Encode(values?.NewPassword),
    });
  };

  return (
    <>
      <div className="bg-img1 background">
        {isCustomerAuthCodeValidated ? (
          <Formik
            initialValues={{ Email: email, NewPassword: "", ConfirmPassword:"" }}
            enableReinitialize
            validationSchema={StoreChangePasswordValidateSchema}
            validateOnBlur={false}
            onSubmit={async (values) => {
              changePassword(values);
            }}
          >
            <Form className="change_password-form login">
              {/* {JSON.stringify(email)}
              {JSON.stringify(authCode)} */}
              <div className="display">
                <div className="logoLogin">
                  <figure>
                    <img src={monozlogo} alt="logo" className="img-fluid"></img>
                  </figure>
                </div>
                <h1 className="fleet_management_heading">
                  <FormattedMessage id="change_password" />
                </h1>
              </div>
              <div className="loginBox">
                <div className=" showHideOuterDiv form-group password_wrapper">
                  <Label
                    className="label-style"
                    required={true}
                    label="email"
                  />
                  <Field
                    className="form-control "
                    name="Email"
                    type="email"
                    disabled={true}
                    autoComplete="new-email"
                    placeholder="enter_email"
                    validcharacter={["@", "#", "$", "-", "_", "."]}
                    as={FormikFormInput}
                  />
                </div>
                <div className=" showHideOuterDiv form-group password_wrapper">
                  <Label required={true} label="user_label_new_password" />
                  <Field
                    data-testid="testPassword"
                    className="form-control"
                    name="NewPassword"
                    type={showHideNewPassword ? "text" : "password"}
                    placeholder="user_label_new_password"
                    invalidcharacter={[" "]}
                    validcharacter={[
                      "~",
                      "`",
                      "!",
                      "@",
                      "#",
                      "$",
                      "%",
                      "^",
                      "&",
                      "*",
                      "(",
                      ")",
                      "_",
                      "-",
                      "+",
                      "=",
                      "{",
                      "[",
                      "}",
                      "]",
                      "|",
                      "\\",
                      ":",
                      ";",
                      "'",
                      '"',
                      "<",
                      ",",
                      ">",
                      ".",
                      "?",
                      "/",
                    ]}
                    as={FormikFormInput}
                  />
                  <ShowHidePasswordButton
                    showHidePassword={showHideNewPassword}
                    setShowHidePassword={setShowHideNewPassword}
                  />
                </div>
                <div className="showHideOuterDiv form-group password_wrapper">
                                          <Label
                                            className="label-style"
                                            required={true}
                                            label="confirm_password"
                                          />
                                          <div className="form-group position-static">
                                            <Field
                                              className="form-control"
                                              autocomplete="new-password"
                                              name="ConfirmPassword"
                                              type={showConfirmPassword ? "text" : "password"}
                                              placeholder="enter_confirm_password"
                                              as={FormikFormInput}
                                              invalidcharacter={[" "]}
                                              validcharacter={[
                                                "~",
                                                "`",
                                                "!",
                                                "@",
                                                "#",
                                                "$",
                                                "%",
                                                "^",
                                                "&",
                                                "*",
                                                "(",
                                                ")",
                                                "_",
                                                "-",
                                                "+",
                                                "=",
                                                "{",
                                                "[",
                                                "}",
                                                "]",
                                                "|",
                                                "\\",
                                                ":",
                                                ";",
                                                "'",
                                                '"',
                                                "<",
                                                ",",
                                                ">",
                                                ".",
                                                "?",
                                                "/",
                                              ]}
                                            />
                                            <ShowHidePasswordButton
                                              showHidePassword={showConfirmPassword}
                                              setShowHidePassword={setShowConfirmPassword}
                                            />
                                          </div>
                                        </div>
                <div className="text-center mt-3">
                  <LoaderButton
                    type="submit"
                    isLoading={props.loading}
                    text="change_password"
                  />
                </div>
              </div>
            </Form>
          </Formik>
        ) : isCustomerAuthCodeValidated == false &&
          authenticateCustomerAuthCodeState.inProgress == true ? (
          <p>Is Verifying</p>
        ) : (
          <div className="change_password-form login">
            <div className="display">
              <div className="logoLogin">
                <figure>
                  <img src={monozlogo} alt="logo" className="img-fluid"></img>
                </figure>
              </div>
              <h1 className="fleet_management_heading">
                <FormattedMessage id="change_password" />
              </h1>
            </div>
            <div className="loginBox">
              <h2 className="text-danger">
                <FormattedMessage id="invalid_link" />
              </h2>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default observer(ResetPassword);
